module.exports = __webpack_public_path__ + "static/img/Pe-icon-7-stroke.d34b56a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/pe-icon-7-stroke/fonts/Pe-icon-7-stroke.svg?-2irksn
// module id = Hg1i
// module chunks = 1